// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"ed32eb21763434fc9fc6","678":"b158832e2d5f09cf03db","883":"8e4d4fca482d753f6fc4"}[chunkId] + ".js";
};